import React from 'react'
import { PackageOptions } from '../../../BreachWallContent/BreachWallContent'
import {
    StyledSubscriptionInnerPriceContainer,
    StyledSubscriptionPriceTextContainer,
    StyledSubscriptionPrice,
    StyledRibbon,
} from '../../SubscriptionPackageRedesign2026.styled'

type FiftyOffSubscriptionInnerPriceContainerProps = {
    packageOptions: PackageOptions
    price: string
    originalPrice?: string
    durationWeeks?: number
    discount?: number
}
export const FiftyOffSubscriptionInnerPriceContainer = ({
    packageOptions,
    price,
    originalPrice,
    durationWeeks = 1,
    discount,
}: FiftyOffSubscriptionInnerPriceContainerProps) => {
    return (
        <StyledSubscriptionInnerPriceContainer>
            <StyledSubscriptionPriceTextContainer>
                {/* If there is a discount, show the original price with a strikethrough style */}
                {discount && discount > 0 ? (
                    <>
                        <StyledSubscriptionPrice
                            packageOptions={packageOptions}
                            isDiscounted
                        >
                            {originalPrice}
                        </StyledSubscriptionPrice>
                        <StyledSubscriptionPrice
                            packageOptions={packageOptions}
                        >
                            {price}
                        </StyledSubscriptionPrice>
                        <StyledRibbon ribbonOption={'bluePillLight'}>
                            <span>Save ${discount * durationWeeks}!</span>
                        </StyledRibbon>
                    </>
                ) : (
                    // Fallback if for whatever reason there is no discount (shouldn't happen)
                    <>
                        <StyledSubscriptionPrice
                            packageOptions={packageOptions}
                        >
                            {price}
                        </StyledSubscriptionPrice>
                    </>
                )}
            </StyledSubscriptionPriceTextContainer>
        </StyledSubscriptionInnerPriceContainer>
    )
}
